<template>
    <v-row style="border-bottom: 1px solid grey">
        <v-col cols="10" md="10">
            <div class="justify-center">
            <template v-if="length > 1">
                <v-icon dense :disabled="index==0" @click="move(index, index-1)" class="pb-1"> {{ index==0 ? 'mdi-cancel' : 'mdi-arrow-up' }}</v-icon>
                <v-icon dense :disabled="index==(length-1)" @click="move(index, index+1)" class="pb-1">{{index==(length-1) ? 'mdi-cancel' : 'mdi-arrow-down'}}</v-icon>
            </template>
            <span style="font-size: 17px;"> {{ index+1 }}. {{ signature.fullname }}</span>
            </div>
        </v-col>
        <v-col cols="2" class="text-right">
            <v-icon v-if="canEditRepresenters" dense @click="deleteSignature" class="pb-1">mdi-delete-outline</v-icon>
        </v-col>
        <v-col cols="12" md="12">
            <v-row>
            <template v-if="signature.phone_number_prepend">
            <v-col cols="12">
                <span class="info-sms-msg">{{showSMSInfo(signature) }}</span>
            </v-col>
            <v-divider></v-divider>
            </template>
            <v-col class="pb-0" cols="4" md="4">
            <el-checkbox
                style="margin-top: 3px"
                label="SMS žinute"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. SMS žinute"
                :tooltipIndexKey= signature.amn_id
                v-model="signature.sms_enabled"
                @click="clickedCheckBox(index, 'sms_enabled', signature.sms_enabled)"
            >
            </el-checkbox>
            </v-col>
            <v-col class="pb-0" cols="8" md="8">
            <v-row no-gutters>
                <v-col cols="2">
                <el-text-field
                    v-model="signature.phone_number_prepend"
                    prependField
                    :validateKey="getKeyPhoneNumber"
                    @change="inputChange"
                />
                </v-col>
            <v-col cols="10">
                <el-text-field
                    style="border-radius: 0px 4px 4px 0px;"
                    phoneNumber
                    :required="phoneNumberReq"
                    label="Telefono numeris"
                    v-model="signature.phone_number"
                    :validateKey="getKeyPhoneNumber"
                    :key="getKeyPhoneNumber"
                    @change="inputChange"
                />
                </v-col>
            </v-row>
            </v-col>
            <v-col class="py-0" cols="4" md="4">
                <el-checkbox
                style="margin-top: 3px"
                label="El. paštu"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. El paštu"
                :tooltipIndexKey= signature.amn_id
                v-model="signature.email_enabled"
                @click="clickedCheckBox(index, 'email_enabled', signature.email_enabled)"
                >
                </el-checkbox>
            </v-col>
            <v-col class="py-0" cols="8" md="8">
                <el-text-field
                email
                label="El. paštas"
                :required="emailAddressReq"
                v-model="signature.email_address"
                :validateKey="getKeyEmailAddress"
                :key="getKeyEmailAddress"
                @change="inputChange"

                />
            </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>

    export default {
        name: 'SingleSignature',
        props: {
            signature: [Array, Object],
            index: [String, Number],
            length: [String, Number],
            canEditRepresenters: [Boolean]
        },
        computed: {
            getKeyPhoneNumber() {
                return `phone-number-${this.index}`
            },
            getKeyEmailAddress() {
                return `email-address-${this.index}`
            },
            phoneNumberReq() {
                return this.signature.sms_enabled
            },
            emailAddressReq() {
                return this.signature.email_enabled
            },
        },
        methods: {
            showSMSInfo(item){
                if(item.phone_number_prepend != '' && (item.phone_number_prepend != '+370' && item.phone_number_prepend != '370') && item.phone_number_prepend != null) {
                    return this.$t('Informuojame, kad trumpieji pranešimai (SMS) siunčiami tik Lietuvoje veikiančių mobiliojo ryšio operatorių registruotiems telefono numeriams.')
                } else {
                    return ''
                }
            },
            deleteSignature() {
                this.$emit('deleteSignature', this.index)
            },
            move(from, to) {
                this.$emit('move', from, to)
            },
            clickedCheckBox(index, property, value){
                this.$emit('clickedCheckBox', index, property, value)
            },
            inputChange() {
                this.$emit('inputChange')
            }
        },
    }
</script>
